export default __webpack_public_path__ + "static/media/excelsiorCL.09c3dd64.webp";